import {
  IAttachedFile,
  IAttachmentChange,
} from 'src/design/organisms/attachments/attachmentTypes';

/** @registry Computes the next controlled attachment list and the change report for a completed upload: a single-slot uploader replaces its one file (reporting the old one as removed), a multi-file uploader appends. */
export const applyUpload = (
  files: IAttachedFile[],
  uploaded: IAttachedFile[],
  singleSlot: boolean,
): { files: IAttachedFile[]; change: IAttachmentChange } =>
  singleSlot
    ? { files: uploaded, change: { added: uploaded, removed: files } }
    : {
        files: [...files, ...uploaded],
        change: { added: uploaded, removed: [] },
      };

/** @registry Folds a FileDrop/ImageUpload change into a form's cumulative add/remove lists, cancelling files that were uploaded and then removed in the same session. */
export const applyAttachmentChange = (
  edits: IAttachmentChange,
  change: IAttachmentChange,
): IAttachmentChange => ({
  added: [
    ...edits.added.filter((a) => !change.removed.some((r) => r.id === a.id)),
    ...change.added,
  ],
  removed: [
    ...edits.removed.filter((r) => !change.added.some((a) => a.id === r.id)),
    ...change.removed.filter((r) => !edits.added.some((a) => a.id === r.id)),
  ],
});
